import { DoorOperationType } from "building-types/doors/doorOperationTypes";
import type { DoorDescriptor } from "building-types/doors/doorTypes";
import { OpeningWrappingModeEnum } from "building-types/openings/openingWrappingModes";
import { doorOperationHasCasing } from "./doorOperation";

export function doorDescriptorHasWrapping(descriptor: DoorDescriptor): boolean {
  if (!descriptor.wrapping) {
    return false;
  }
  return descriptor.wrapping.wrappingMode !== OpeningWrappingModeEnum.NONE;
}

export function doorDescriptorHasCasing(descriptor: DoorDescriptor): boolean {
  if (!descriptor) {
    return false;
  }
  if (!descriptor.includeTrim) {
    return false;
  }
  if (descriptor.operationType === DoorOperationType.ARC && descriptor.isExterior === false) {
    return false;
  }
  return doorOperationHasCasing(descriptor.operationType);
}

export function doorDescriptorHasInteriorCasing(descriptor: DoorDescriptor): boolean {
  return descriptor && doorOperationHasCasing(descriptor.operationType);
}
